import React from "react";
import Contact_Banner from "./contact-banner/Contact_Banner";
import Get_In_Touch from "./get-in-touch/Get_In_Touch";
import Map_Contact from "./map-contact/Map-Contact";
import Banner_2 from "./banner_2/Banner_2";

function Contact_Us() {
  return (
    <>
      <Contact_Banner />
      <Get_In_Touch />
      <Map_Contact />
      <Banner_2 />
    </>
  );
}

export default Contact_Us;
